export default "__VITE_ASSET__Bzj5K$GG__"